import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { templateData } from "./templateData";
import {
  getTemplateByName,
  createTemplate,
  updateTemplate,
} from "./api/template.service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export default function TemplateEditor() {
  const navigate = useNavigate();
  const { id } = useParams();

  const eventId  = useSelector((state) => state?.users?.id || "");
console.log("even",eventId )
  const defaultTemplate = templateData.find(
    (t) => t.id === Number(id)
  );

  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [isNew, setIsNew] = useState(false);
  const [dbId, setDbId] = useState(null); // 🔥 important

  useEffect(() => {
    loadTemplate();
  }, [id]);

  const loadTemplate = async () => {
    try {
      const data = await getTemplateByName(
        defaultTemplate.name,
        eventId 
      );

      if (data) {
        // ✅ DB DATA
        setSubject(data.subject);
        setContent(data.content);
        setDbId(data.id); // 🔥 store DB id
        setIsNew(false);
      } else {
        // ✅ FIRST TIME → fallback
        setSubject(defaultTemplate?.subject || "");
        setContent(defaultTemplate?.content || "");
        setIsNew(true);
      }
    } catch (err) {
      console.log("Fallback to default");

      setSubject(defaultTemplate?.subject || "");
      setContent(defaultTemplate?.content || "");
      setIsNew(true);
    }
  };

  const handleSave = async () => {
    try {
      if (isNew) {
        // 🔥 CREATE
        const res = await createTemplate({
          eventId ,
          name: defaultTemplate.name,
          subject,
          content,
        });

        toast.success("Created Successfully!");

        // 🔥 reload to get DB id
        await loadTemplate();
      } else {
        // 🔥 UPDATE
        await updateTemplate(dbId, {
          eventId ,
          subject,
          content,
        });

        toast.success("Updated Successfully!");
      }
    } catch (err) {
      console.error(err);
      toast.error("Save failed ❌");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* TOP */}
      <span
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer", display: "block", marginBottom: "10px" }}
      >
        ← Back
      </span>

      {/* SUBJECT */}
      <input
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "10px",
          border: "1px solid #ccc",
        }}
      />

      {/* EDITOR */}
      <ReactQuill value={content} onChange={setContent} />

      {/* BUTTON */}
      <button
        onClick={handleSave}
        style={{
          marginTop: "15px",
          padding: "10px 16px",
          background: "#4CAF50",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        {isNew ? "Create Template" : "Update Template"}
      </button>
    </div>
  );
}
const styles = {
  container: {
    padding: "20px",
    background: "#f5f6fa",
    height: "100vh",
  },

  topBar: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px",
  },

  saveBtn: {
    background: "#4CAF50",
    color: "#fff",
    padding: "8px 16px",
    border: "none",
  },

  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    border: "1px solid #ccc",
  },

  editor: {
    background: "#fff",
    borderRadius: "6px",
    border: "1px solid #ddd",
    overflow: "hidden",
  },

  variables: {
    marginTop: "10px",
  },

  varBtn: {
    margin: "5px",
    padding: "5px 10px",
    background: "#ddd",
    cursor: "pointer",
  },
};